import React from 'react';

import { useBrand } from '@atc/brand';
import { getConsumerInsights } from '@atc/consumer-insights';
import { getPixallId } from '@atc/pixall-fns';

const WestlakeRetargetingContainer = ({
    personalization,
    listing,
    page,
    user,
}) => {
    const { isBrand } = useBrand();
    const isKbb = isBrand('kbb');

    const url = new URL(window.location);

    const PSID_LNX = isKbb ? url?.searchParams.get('psid') : url?.searchParams.get('lnx');

    const consumerInsights = {
        ...getConsumerInsights(),
        ...personalization, // Merge in personalization data if available
    };

    const pixallId = getPixallId();

    const googleFloodlightPath = `https://ad.doubleclick.net/ddm/activity/src=8951737;type=westl0;cat=westl0;
    u1=${listing?.make};
    u2=${listing?.model};
    u3=${listing?.bodyStyleCodes && listing?.bodyStyleCodes[0]};
    u4=${listing?.year};
    u5=${listing?.type};
    u6=${page?.pageName};
    u7=${listing?.pricingDetail?.salePrice};
    u8=${user?.dma};
    u9=${consumerInsights.MkOfPrefMdl};
    u10=${consumerInsights.PrefMdl};
    u12=${consumerInsights.MkOfSecPrefMdl};
    u13=${consumerInsights.SecPrefMdl};
    u14=${consumerInsights.MktLevel};
    u16=${consumerInsights.PrefPrice};
    u18=${consumerInsights.PrefVehType};
    u20=${consumerInsights.PriceSensitivity};
    u21=${consumerInsights.PrefMk};
    u23=${consumerInsights.PrefBstyl};
    u25=${consumerInsights.FixedOps};
    u26=${consumerInsights.PrefMileage};
    u29=${consumerInsights.RecPrefMk};
    u30=${consumerInsights.RecPrefMdl};
    u31=${consumerInsights.MkOfRecPrefMdl};
    u32=${user?.ivtMoatFlag};
    u33=${PSID_LNX || ''};
    u46=${pixallId};
    dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=\${GDPR};gdpr_consent=\${GDPR_CONSENT_755};ord=1?`;

    const retargetingData = {
        atc: [
            googleFloodlightPath,
            'https://pubads.g.doubleclick.net/activity;dc_iu=/18353239/DFPAudiencePixel;ord=2771021502828807;dc_seg=7982832342?',
            'https://www.facebook.com/tr?id=1088220411210535&ev=Westview&noscript=1',
        ],
        kbb: [
            googleFloodlightPath,
            'https://pubads.g.doubleclick.net/activity;dc_iu=/3030/DFPAudiencePixel;ord=5808778018589222;dc_seg=7982318243?',
            'https://www.facebook.com/tr?id=1511218289206949&ev=Westview&noscript=1',
        ],
    };

    const paths = isKbb ? retargetingData.kbb : retargetingData.atc;

    return (
        paths.map((path, index) => (
            <img
                key={index}
                width="1"
                height="1"
                src={path}
                alt=""
            />
        ))
    );
};

export default WestlakeRetargetingContainer;
